import api from "../api/api";

export const useSubscribeNewsLetter = async (body: any) => {
  return await api.post("/web/v1/newsletter-subscriptions", body);
};
